<template>
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 2.82353V4.23529H6V2.82353C6 2.04485 5.32734 1.41176 4.5 1.41176C3.67266 1.41176 3 2.04485 3 2.82353ZM1.5 4.23529V2.82353C1.5 1.26397 2.84297 0 4.5 0C6.15703 0 7.5 1.26397 7.5 2.82353V4.23529C8.32734 4.23529 9 4.86838 9 5.64706V10.5882C9 11.3669 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3669 0 10.5882V5.64706C0 4.86838 0.672656 4.23529 1.5 4.23529Z"
            fill="currentColor" />
    </svg>
</template>